module.exports = __webpack_public_path__ + "static/media/11_3.ae0b24d9.png";